// extracted by mini-css-extract-plugin
export var copyright = "Footer-module--copyright--a775b";
export var inner = "Footer-module--inner--461ba";
export var nav = "Footer-module--nav--fce49";
export var nav__item = "Footer-module--nav__item--a0315";
export var nav__link = "Footer-module--nav__link--740aa";
export var nav__list = "Footer-module--nav__list--aff3f";
export var wrap = "Footer-module--wrap--73f72";